import { connect } from 'react-redux';


import { showSettingsSideMenu, hideSettingsSideMenu }
  from '../../redux/actions/settings.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import SettingsView from './SettingsView.jsx';
import {trackAdoptionMetricsForContentSourceClickedEvent,trackAdoptionMetricsForIntegrationsClickedEvent, trackAdoptionMetricsForSettingsScreenView} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
  return {
    'account': state.accounts.item,
    'user': state.users.me,
    'showSettingsMenu': state.legacyRootReducer.settings.settingsMenu.showSettingsMenu
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
      return dispatch(showSettingsSideMenu());
    },

    hideSettingsSideMenu : () => {
        return dispatch(hideSettingsSideMenu())
    },
    trackAdoptionMetricsForContentSourceClickedEvent: () =>{
      return dispatch(trackAdoptionMetricsForContentSourceClickedEvent())
    },
    trackAdoptionMetricsForIntegrationsClickedEvent: () =>{
      return dispatch(trackAdoptionMetricsForIntegrationsClickedEvent());
    },
    trackAdoptionMetricsForSettingsScreenView: () => {
      return dispatch(trackAdoptionMetricsForSettingsScreenView());
    }
  }
}

const SettingsPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SettingsView);

export default withUseHooks(SettingsPage);